import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import {
    getUpdateDynamicLottieImagePathPUTUrl,
    getUpdateFontForDynamicLottiePUTUrl,
    getUploadImageToTakePOSTUrl,
} from '../../../../../constants/private/urls/projects/take/take-dynamic-lottie.urls';
import { ITakeDynamicLottieContext, ITakeInDTO } from '../../../../../models/project/take/take-model';
import { IUpdateTakeDynamicFontRequestBody } from '../../../../http-models/project/take/take-http-request-model';
import { MissingArgumentsError } from '../../../../../models/errors/general.errors';

export interface IUpdateTakeImageBody {
    existingImage?: {
        relativeImagePath: string;
    };
    selectPhoto?: {
        photoId: string;
    };
}

@Injectable()
export class TakeDynamicLottieApiService {
    constructor(private http: HttpClient) {}

    updateDynamicLottieImagePath$(
        projectId: string,
        sceneId: string,
        takeId: string,
        dynamicLottieId: string,
        action: IUpdateTakeImageBody
    ) {
        const url = getUpdateDynamicLottieImagePathPUTUrl(projectId, sceneId, takeId, dynamicLottieId);

        return this.http.put<ITakeInDTO>(url, action);
    }

    uploadImage$(formData: FormData, projectId: string, sceneId: string, takeId: string, dynamicLottieId: string) {
        const url = getUploadImageToTakePOSTUrl(projectId, sceneId, takeId, dynamicLottieId);

        return this.http.post<ITakeInDTO>(url, formData, {
            reportProgress: true,
            observe: 'events',
        });
    }

    changeFont$(data: IUpdateTakeDynamicFontRequestBody) {
        if (!data || !data.font || !data.context) {
            throw new MissingArgumentsError(`No data to change font provided!`);
        }
        const url = getUpdateFontForDynamicLottiePUTUrl(data.context);

        return this.http.put<ITakeInDTO>(url, { font: data.font });
    }
}
